<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="image"><a id="page_xi"></a><img alt="Image" src="images/common1.jpg"/></p>
<p class="parag"><em>To the glory of God with thanksgiving<br/>for the wonder of life.</em></p>
<p class="parag">     —Inscription on the grave of Eli Lilly,<br/>         Crown Hill Cemetery, Indianapolis</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?42054e52